"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _qs = _interopRequireDefault(require("qs"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FilterPill = _interopRequireDefault(require("../filter-pill/FilterPill"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _shared = require("@insided/destination/modules/Navigation/shared");

var _categories = require("@insided/shared/utils/categories");

/**
 * List of filter keys to watch for in URL query parameters
 */
var FILTERS_LIST = ['productArea', 'ideationStatus', 'category'];

/**
 * MobileFilterList Component
 *
 * Mobile-only filter list that displays active filters as dismissable pills.
 * This component is intentionally NOT rendered server-side (SSR) because:
 *
 * 1. It's mobile-only (hidden on desktop with `is-hidden-L` class)
 * 2. Rendering it server-side would add unnecessary HTML to the initial payload
 * 3. It depends on browser-only APIs (window.location, document.body)
 *
 * @example
 * ```tsx
 * <MobileFilterList
 *   categories={[{ id: 1, title: 'Product A' }]}
 * />
 * ```
 */
var MobileFilterList = function MobileFilterList(_ref) {
  var _qs$parse$filters;

  var categories = _ref.categories;

  // SSR Guard: Don't render on server-side
  // TODO:
  // Access searchParams on the server-side rendering context
  // or
  // Create skeleton/loading state for SSR
  if (typeof window === 'undefined') {
    return null;
  } // Build category mapping from categories array


  var categoryMapping = (0, _categories.getCategoryIdTitleMapping)(categories !== null && categories !== void 0 ? categories : []); // Parse URL filters (browser-only)

  var searchQuery = window.location.search;
  var filters = (_qs$parse$filters = _qs.default.parse(searchQuery, {
    ignoreQueryPrefix: true
  }).filters) !== null && _qs$parse$filters !== void 0 ? _qs$parse$filters : {};
  var filterKeys = Object.keys(filters).filter(function (filter) {
    return FILTERS_LIST.includes(filter);
  }); // Side effect: Add/remove body class based on filters
  // TODO: don't do that on rendering phase, use case for componentDidUpdate

  if (filterKeys.length) {
    document.body.classList.add('filters-applied');
  } else {
    document.body.classList.remove('filters-applied');
  } // Guardian clause: Early return if no filters


  if (!filterKeys.length) {
    return null;
  }

  var handleResetFilters = function handleResetFilters() {
    window.dispatchEvent(new CustomEvent('resetFilters'));
  };

  return (0, _preact.h)("ul", {
    className: "filter-list is-hidden-L"
  }, filterKeys.filter(function (key) {
    return key !== 'productArea' && key !== 'ideationStatus';
  }).map(function (filterKey) {
    var filterValue = filters[filterKey][0];
    return (0, _preact.h)(_FilterPill.default, {
      key: filterValue,
      name: (0, _shared.getFilterName)(filterKey, filterValue, categoryMapping),
      onClick: function onClick() {
        return (0, _shared.dispatchFilterRemovalEvent)(filterKey);
      },
      isDismissable: true
    });
  }), filterKeys.length > 1 ? (0, _preact.h)("li", {
    className: (0, _classnames.default)('link', 'link--underline', 'filter-reset-link'),
    onClick: handleResetFilters
  }, (0, _preact.h)(_phrase.default, {
    m: "Common",
    p: "advanced.search.filter.clear.all"
  })) : null);
};

var _default = MobileFilterList;
exports.default = _default;